
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';
    import { Transporte } from '@/__env/lib/Expedicion/Transportes';
    import { Cliente } from '@/__env/lib/Clientes';
    import { PresetImportarExcel } from '@/__env/lib/Ventas/ImportarExcel/Presets/Preset.nav';
    import { Utiles, utf8_to_b64, b64_to_utf8 } from '@/__env/pluggins/event-bus';
    import { Wait } from '@/__env/ext';
    import editar from './lista-buscador-presets-editar.vue';
    import { IColumna } from '@/__env/lib/Ventas/ImportarExcel/Presets/Preset.lib';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import { Tipos as TiposPedido } from '@/__env/lib/Ventas/Pedidos/Pedido.types';
    import * as Pedidos from '@/__env/lib/Ventas/Pedidos';

    @Component( {
        name: "Componente",
        props: {},
        components: {
            editar
        }
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorSeccion;

        public Abierto: boolean = false;
        @Watch( 'Abierto' )
        onAbierto()
        {
            if ( this.Abierto )
            {

            }
        }

        public Cargando: boolean = false;
        public Tipo: number = -1;
        public Tipos = TiposPedido.Plataformas;

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }



        public Ok()
        {
            return !this.Controlador.HayErrores() && this.Tipo >= 0 && Object.keys( this.Controlador.Preset ).hasRows();
        }






        Ejecutar()
        {
            this.Controlador.Tipo = TiposPedido.Plataformas[this.Tipo];
            let data = this.Controlador.ObtenerDatos();

            for ( let dat of data )
            {
                //if ( this.Controlador.Tipo.ClientePredeterminado )
                //    dat['cliente-id'] = this.Controlador.Tipo.ClientePredeterminado.toString();
            }

            let js = { tipo: this.Controlador.Tipo.Id, datos: data };
            let js64 = utf8_to_b64( JSON.stringify( js ) );
            //console.log( js64 );
            //console.log( b64_to_utf8( js64 ) );
            //this.Controlador.Vista.Estado = 'pedidos';
            this.$router.push( '/pedidos/plataformas/continuar?d=' + js64)
        }



        Cerrar()
        {
            this.Abierto = false;
        }

        public Refresh: boolean = false;
        Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }
    }
